__turbopack_context__.v({
  "className": "Xzo59W_className",
  "variable": "Xzo59W_variable",
});
